export default stickyNav => {
    // console.log('stickyNav');
    const ww = window.innerWidth;
    const body = document.querySelector('body');
    const stickyNavHeight = stickyNav.offsetHeight;

    let capability = 0;
    let topPos = 0;

    function scrollCheck() {
        switch (capability) {
            case 1:
                topPos = window.pageYOffset;
                break;
            case 2:
                topPos = document.body.scrollTop;
                break;
            default:
                topPos = 0;
                break;
        }
    }

    function init() {
        if (window.pageYOffset !== undefined) {
            capability = 1;
        } else if (document.body && document.body.scrollTop !== undefined) {
            capability = 2;
        }

        window.addEventListener('scroll', () => {
            scrollCheck();

            if (topPos >= 250) {
                body.style.paddingTop = `${stickyNavHeight}px`;
                stickyNav.classList.add('sticky');
            } else {
                body.style.paddingTop = 0;
                stickyNav.classList.remove('sticky');
            }
        });
    }

    ww >= 992 && init();


    if(ParamsData.floodlight != ""){
      let formBooks = document.querySelectorAll('form.header-booking-form');
      for(var i=0;i<formBooks.length;i++){
        let formBook = formBooks[i];
        formBook.addEventListener('submit', function(event) {
            //event.preventDefault();

            var axel = Math.random() + "";
            var a = axel * 10000000000000;
            var htmlIframe = '<iframe src="https://10853174.fls.doubleclick.net/activityi;src=10853174;type=invmedia;cat=' + ParamsData.floodlight + ';dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=1;num=' + a + '?" width="1" height="1" frameborder="0" style="display:none"></iframe>';
            var newNode = document.createElement('div');
            newNode.innerHTML = htmlIframe;
            var parentNode = document.querySelector('body');
            parentNode.insertBefore(newNode, parentNode.firstChild);

        });
      }
    }


};
